import { BrowserOptions } from '@sentry/nextjs';

import { getServerEnv, isBuild } from '@flipster/utils/env-helper';

export const SentryConfig: BrowserOptions = {
  dsn: 'https://cfbbc126e4ffeccdf33c7c7702e7299a@o356035.ingest.sentry.io/4506312827076608',
  release: `prex-frontend-nextjs@${process.env.NEXT_PUBLIC_VERSION ?? 'test'}`,
  environment: getServerEnv(),
  beforeSend(event) {
    if (!isBuild) return null;
    return event;
  },
};
